import { Box, FormControlLabel, Switch, Tooltip, Typography } from "@mui/material";
import HelpOutlineSharpIcon from "@mui/icons-material/HelpOutlineSharp";
import { zoullooColors } from "../../../../../theme";
import { FormikProps } from "formik";
import { useTranslation } from "react-i18next";
import { FreelancerOnboardingMyPresentationStepViewModel } from "../../../../../ViewModels/FreelancerOnboardingMyPresentationStepViewModel";

interface FreelancerOnboardingTrainerSectionProps {
	readonly formik: FormikProps<FreelancerOnboardingMyPresentationStepViewModel>;
}

export default function FreelancerOnboardingMyPresentationTrainerBloc({
	formik
}: FreelancerOnboardingTrainerSectionProps) {
	const { t } = useTranslation();

	return (
		<Box sx={{ marginBottom: 4 }}>
			<FormControlLabel
				control={
					<Switch
						checked={formik.values.isTrainer}
						onChange={e => formik.setFieldValue("isTrainer", e.target.checked)}
						color="secondary"
					/>
				}
				label={
					<Box>
						<Typography variant="h3" component="span">
							{t("freelancerOnboardingMyPresentation.trainer.title")}
							<Tooltip
								title={<Typography variant="body2">{t("freelancerOnboardingMyPresentation.trainer.tooltip")}</Typography>}
								arrow
								slotProps={{
									tooltip: {
										sx: { maxWidth: "none !important" }
									}
								}}
							>
								<HelpOutlineSharpIcon
									fontSize="small"
									sx={{ ml: 0.5, color: zoullooColors.grey[400], cursor: "help", verticalAlign: "middle" }}
								/>
							</Tooltip>
						</Typography>
						<Typography variant="body2" color="text.secondary">
							{t("freelancerOnboardingMyPresentation.trainer.description")}
						</Typography>
					</Box>
				}
			/>
		</Box>
	);
}
